import React, {useState} from "react";
import {FieldViewSize} from "../../../../const";

export default function FieldPopover_InlineValueNotEmptyV2(props:any) {


    const onDeleteClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()

        props.onReset && props.onReset(null)
    }

    const size = _.get(props, 'size', FieldViewSize.DEFAULT)

    const [isHovered, setIsHovered] = useState(false)

    const toggleIsHovered = () => {
        setIsHovered(!isHovered)
    }

    const onMouseEnter = () => {
        if (!isHovered) setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (isHovered) setIsHovered(false)
    }


    const className = Classes("ui5-field-editable", "size-"+size, props.className, {
        'is-hovered'        : isHovered || props.children
    })

    const valueClass = Classes({
        'ui5-txt-default'               : size === FieldViewSize.DEFAULT,
        'ui5-txt-less-important-small'  : size === FieldViewSize.SMALL,
    })



    if (isHovered || props.children) {
        return (
            <React.Fragment>
                <div className={className} onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                    <div className={valueClass}>
                        {_.get(props.field.components, 'ValueIcon', false)}
                        {_.get(props.field.components, 'ValuePrefix', false)}
                        {props.field.getDisplayValue(props.value)}
                    </div>


                    <div className="buttons">
                        {props.field.clearButton && <div className="btn-reset" onClick={onDeleteClick}/>}
                        {!props.field.clearButton && <div className="btn-arrow"/> }
                    </div>
                </div>
                {props.children}
            </React.Fragment>
        )
    }

    // not hovered
    return (
        <React.Fragment>
            <div className={Classes(className, valueClass)} onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                {_.get(props.field.components, 'ValueIcon', false)}
                {_.get(props.field.components, 'ValuePrefix', false)}
                {props.field.getDisplayValue(props.value)}
            </div>
            {props.children}
        </React.Fragment>
    )


}
